export const FILTER_BY_DATE_OPTIONS = [
  {
    label: "All time",
    queryStr: "",
  },
  {
    label: "Last 90 days",
    queryStr: "days_ago=90",
  },
  {
    label: "Last year",
    queryStr: "days_ago=365",
  },
]

export const FILTER_BY_STATUS_OPTIONS = [
  "In-Progress",
  "Review",
  "Approved",
  "Approved, not published",
  "Processed",
  "Canceled",
]
